module.exports = __webpack_public_path__ + "img/9.24f0bc42.jpg";